import styled from 'styled-components'
import { Title16, Body12 } from 'components/Typography'
import theme from 'styles/theme'

export const ProductCardHeading = styled(Title16)`
  color: ${theme.colors.sagedark};
  word-break: break-word;
  white-space: normal;
  text-align: left;
  display: flex;
  justify-content: flex-start;
`

export const ProductCardBrand = styled(Body12)`
  color: ${theme.colors.sagedark};
  text-align: left;
`

export const ProductCardContainer = styled.div`
  word-break: break-word;
  white-space: normal;
`
